function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Check_mark_rounded_Copy",
  "data-name": "Check mark rounded Copy",
  d: "M13.5,27A13.5,13.5,0,1,1,27,13.5,13.516,13.516,0,0,1,13.5,27Zm0-25.471A11.972,11.972,0,1,0,25.473,13.5,11.986,11.986,0,0,0,13.5,1.529ZM11.967,17.388a.76.76,0,0,1-.538-.223L8.244,13.98A.763.763,0,1,1,9.324,12.9l2.643,2.643,5.711-5.707a.764.764,0,0,1,1.08,1.08l-6.251,6.249A.762.762,0,0,1,11.967,17.388Z",
  fill: "#ff7643"
});

var SvgIconChecklistRoundedFull = function SvgIconChecklistRoundedFull(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconChecklistRoundedFull, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-checklist-rounded-full.925eb239.svg";
export { ForwardRef as ReactComponent };